/* eslint-disable react/prop-types */
import { Controller } from "react-hook-form";
import { TextField } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import dayjs from "dayjs";



const RHFDatePicker = ({ formData, control, isDisabled }) => {
  // Generate validation rules dynamically
  const rules = formData?.Validations?.reduce((acc, validation) => {
    if (validation.ValidationType === "Required") {
      acc.required = validation.ValidationMessage || "This field is required";
    }
    return acc;
  }, {});

    return ( 
    <Controller
      name={formData?.ValueExpr}
      control={control}
      rules={rules}
      render={({ field, fieldState: { error } }) => (
        <LocalizationProvider
          dateAdapter={AdapterDayjs}
          size="small"
          sx={{ fontSize: "13px" }}
          localeText={{
            fieldMonthPlaceholder: () => "MMM",
          }}
          fullWidth
          >             
              <DatePicker
                  fullWidth
                  sx={{width:'100%'}}
                  {...field}
                  format="DD/MMM/YYYY"
                  views={["year", "month", "day"]}
                  slotProps={{
                      textField: {
                          size: "small",
                          fontSize: "13px",
                          // error: !!error, // Passes error state to the TextField
                          helperText: error && (
                              <span style={{ color: "red", fontSize: "10px" }}>{error.message}</span>
                          ),
                          InputProps: { sx: { fontSize: "13px" } }, // Adjusts the input field text size
                          InputLabelProps: { sx: { fontSize: "14px" } }, // Adjusts the label text size
                      },

                      popper: {
                          placement: "top", // or 'bottom-start', 'top-end', etc., depending on your layout
                          modifiers: [
                              {
                                  name: "preventOverflow",
                                  options: {
                                      altAxis: true, // shifts the popper along the secondary axis to prevent overflow
                                  },
                              },
                          ],
                      },
                  }}
                  label={<>{formData?.LabelName || formData?.DisplayExpr}{rules?.required && (
                      <span style={{ color: isDisabled ? 'inherit' : "red", marginLeft: "2px" }}>*</span>
                  )}</>}
                  value={field.value ? dayjs(field.value) : null} // Ensures the value is parsed as a dayjs object
                  disabled={isDisabled}
                  onChange={(date) => {
                      if (dayjs(date).isValid()) {
                          field.onChange(dayjs(date).format("DD/MMM/YYYY"));
                      } else {
                          field.onChange(null); // Removes invalid date
                      }
                  }}

                  renderInput={(params) => (
                      <TextField
                          {...params}
                          variant="outlined"
                          size="small"
                          error={!!error}
                         // helperText={error ? error.message : ""}
                          
                          fullWidth
                          sx={{
                              "& .MuiInputBase-input": {
                                  fontSize: "13px",
                              },
                              "& .MuiFormLabel-root": {
                                  fontSize: "14px",
                              },
                          }}
                      />
                  )}
              />
        </LocalizationProvider>
      )}
    />
     
  );
};

export default RHFDatePicker;
